import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const Clock = ({ timeZone = 'UTC' }) => {
  const { t } = useTranslation();
  const [time, setTime] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();

      const options = {
        // weekday: 'short', // Fri
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone,
      };

      const weekday = {
        weekday: 'short', // Fri
        timeZone,
      };

      // Always produce a string here
      const dayOfWeek = new Intl.DateTimeFormat('en-GB', weekday).format(now);
      const formatted = new Intl.DateTimeFormat('en-GB', options).format(now);

      const formattedWithDay = `${t('WEEKDAYS', { returnObjects: true }).find(day => day.value === dayOfWeek).label} ${formatted}`; // dayOfWeek

      setTime(formattedWithDay.replace(',', ''));
    }, 1000);

    return () => clearInterval(interval);
  }, [timeZone]);

  return <span>{time}</span>;
};
